import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  inject
} from "@angular/core";
import {
  ChildEntityDeletionBehaviour,
  ChildEntityModel
} from "@app/view/shared/child-entity-manager/child-entity-model";
import { MatDialog } from "@angular/material/dialog";
import {
  MatListItem,
  MatListOption,
  MatSelectionList
} from "@angular/material/list";
import { BaseEntity } from "@app/models/rest/base-entity";
import { PagedGetOption } from "@lagoshny/ngx-hateoas-client";
import {
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import { MatChip, MatChipSet } from "@angular/material/chips";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { NgTemplateOutlet } from "@angular/common";
import { ChildEntityDisplayResolverComponent } from "../child-entity-display-resolver/child-entity-display-resolver.component";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-child-entity-manager",
  templateUrl: "./child-entity-manager.component.html",
  styleUrls: ["./child-entity-manager.component.scss"],
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatChipSet,
    MatChip,
    MatProgressSpinner,
    MatExpansionPanelDescription,
    NgTemplateOutlet,
    MatSelectionList,
    MatListOption,
    ChildEntityDisplayResolverComponent,
    MatListItem,
    MatButton,
    TranslatePipe
  ]
})
export class ChildEntityManagerComponent implements OnInit, OnChanges {
  dialog = inject(MatDialog);

  isLoading = true;
  @ViewChild("childSelect", { static: false }) childSelect: MatSelectionList;

  @Output() public entityChange = new EventEmitter<any>();
  public entities: Array<BaseEntity>;

  private _resource: BaseEntity;

  @Input()
  set resource(resource: BaseEntity) {
    this._resource = resource;
  }

  private _childEntityModel: ChildEntityModel<BaseEntity, BaseEntity>;

  get childEntityModel(): ChildEntityModel<BaseEntity, BaseEntity> {
    return this._childEntityModel;
  }

  @Input()
  set childEntityModel(
    childEntityModel: ChildEntityModel<BaseEntity, BaseEntity>
  ) {
    this._childEntityModel = childEntityModel;
  }

  private _panelMode: boolean = true;

  get panelMode() {
    return this._panelMode;
  }

  @Input()
  set panelMode(panelMode: boolean) {
    this._panelMode = panelMode;
  }

  ngOnInit() {
    this.reload();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.reload();
  }

  deleteSelected() {
    // console.log(
    //   `Running delete, mode=${this.childEntityModel.deletionBehaviour}`
    // );

    if (
      this.childEntityModel.deletionBehaviour ===
      ChildEntityDeletionBehaviour.LINK_TABLE
    ) {
      this.childSelect.selectedOptions.selected.forEach((selected) => {
        // console.log("selected items for deletion");
        // console.log(selected);
        this.childEntityModel.store.delete(selected.value).subscribe(() => {
          this.ngOnInit();

          this.entityChange.emit({});
        });
      });
    } else if (
      this.childEntityModel.deletionBehaviour ===
      ChildEntityDeletionBehaviour.RELATIONSHIP
    ) {
      // console.log("performing relationship based deletion");
      this.isLoading = true;
      this.processNextRelationshipDelete(
        this.childSelect.selectedOptions.selected
      );
    }
  }

  openAddDialog(): void {
    const dialogRef = this.dialog.open(this.childEntityModel.addComponent, {
      width: this.childEntityModel.addWidth ?? "350px",
      data: { mode: "EDIT", resource: this._resource }
    });

    dialogRef.afterClosed().subscribe(() => {
      // console.log("The dialog was closed");
      // console.log(result);
      this.reload();
      this.entityChange.emit({});
    });
  }

  private reload() {
    this.isLoading = true;

    if (!this._childEntityModel || !this._resource) return;

    const params: PagedGetOption = { params: {} };
    params.params[this._childEntityModel.searchKey] =
      this._resource.getSelfLinkHref();
    this.childEntityModel.store
      .loadWithSearch(this._childEntityModel.searchQuery, params, true)
      .then((value) => {
        // console.log("loaded resource");
        this.entities = value.resources;
        this.isLoading = false;
      });
  }

  private processNextRelationshipDelete(selected: MatListOption[]) {
    const related: BaseEntity = selected.pop().value;
    // console.log(this);
    // console.log(this._resource);
    this._resource
      .deleteRelation(this.childEntityModel.parentRelation, related)
      .subscribe(() => {
        // console.log("relationship removed");
        // console.log(value);
        this._childEntityModel.parentStore
          .loadSingle(this._resource.id, true)
          .then((refreshedResource) => {
            this._resource = refreshedResource;
            if (selected.length > 0) {
              this.processNextRelationshipDelete(selected);
            } else {
              this.ngOnInit();

              this.entityChange.emit({});
            }
          });
      });
  }
}
